<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-26 15:58:03
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-27 18:09:13
 * @FilePath: /goldenSalesMobile/src/views/AccountCenter/index.vue
 * @Description: 个人中心
-->
<template>
  <div class="page-container">
    <!-- <nav-bar title="个人中心" /> -->
    <div class="main-box">
      <img class="avatar" src="../../assets/account_image/avatar.png" alt="" />
      <p class="user-name">{{ userInfo.Name }}</p>
      <p class="user-phone">{{ userInfo.Phone }}</p>
      <div class="user-commision">
        <p>累计佣金</p>
        <p>
          ￥
          <a>{{ userInfo.Amount }}</a>
        </p>
        <p>您或者您的团员分销成功均可获得奖励</p>
        <router-link
          tag="span"
          :to="{
            name: 'SalerCommision',
            params: {
              withdrawableAmount: userInfo.WithdrawableAmount,
              totalAmount: userInfo.TotalAmount,
              frozenAmount: userInfo.FrozenAmount,
            },
          }"
        >
          <g-arrow color="#CCA567" />
        </router-link>
      </div>
      <div class="group-info">
        <div class="info-wrap">
          <p>
            <span
              ><a>{{ groupInfo.memberCount }}</a
              >名团队成员</span
            >
            <span
              >邀请好友加入即可获得{{ groupInfo.inviteCommision }}元佣金</span
            >
          </p>
          <div class="enter-links">
            <router-link to="/saler-group"
              >查看团队明细<g-arrow :size="12" color="#CCA567"
            /></router-link>
            <router-link
              :to="{
                path: '/invite-poster',
                query: { id: userInfo.Id, headId: userInfo.HeadId },
              }"
              >邀请团员加入<g-arrow :size="12" color="#CCA567"
            /></router-link>
          </div>
        </div>
        <span class="border-bottom"></span>
      </div>
    </div>
    <div class="service-tel">
      <span>
        <svg-icon iconClass="service-tel" />
        客服电话
      </span>
      <span
        ><a :href="'tel:' + serviceTel">{{ serviceTel }}</a></span
      >
    </div>
    <div class="logout-btn" @click="onLogout">
      <span>退出登录</span>
    </div>
    <g-copy-right />
  </div>
</template>

<script>
import { getDistributorInfo, logOut } from "@/api/user";
import { removeToken } from "@/utils/auth";
export default {
  data() {
    return {
      serviceTel: "010-2345-3322",
      userInfo: {},
      groupInfo: {
        memberCount: 0,
        inviteCommision: 0,
      },
    };
  },

  created() {
    this.init();
  },

  methods: {
    // 初始化：获取推销员信息
    init() {
      getDistributorInfo().then((res) => {
        this.userInfo = res;
      });
    },

    // 退出登录
    onLogout() {
      logOut().then((res) => {
        if (res) {
          removeToken();
          this.$router.replace({
            name: "Login",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  .main-box {
    @include flex-box(flex-start, center);
    flex-direction: column;
    margin-bottom: 22px;
    overflow: hidden;
    background: $blockBgColor;

    .avatar {
      display: block;
      width: 188px;
      height: 188px;
      margin: 24px auto 0;
    }

    .user-name {
      margin-bottom: 12px;
      text-align: center;
      line-height: 56px;
      font-size: 40px;
      font-weight: 500;
      color: $secondFontColor;
    }

    .user-phone {
      text-align: center;
      line-height: 40px;
      font-size: 28px;
      font-weight: 400;
      color: $baseFontColor;
    }

    .user-commision {
      @include flex-box(center, center);
      flex-direction: column;
      position: relative;
      width: 670px;
      height: 228px;
      background: url("../../assets/account_image/commision_bg.png");
      background-size: cover;

      > p:first-child {
        margin: 20px 0 12px;
        text-align: center;
        line-height: 42px;
        font-size: 30px;
        color: #fff;
      }

      > p:nth-child(2) {
        margin-bottom: 22px;
        text-align: center;
        font-size: 22px;
        line-height: 1;
        font-weight: 600;
        color: #fff;

        > a {
          font-size: 48px;
        }
      }

      > p:nth-of-type(3) {
        font-size: 24px;
        font-weight: 500;
        color: #fff;
        line-height: 34px;
        opacity: 59%;
      }

      > span {
        position: absolute;
        right: 30px;
        top: 50%;
        margin-top: -20px;
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 50%;
        background: #ffffff;
      }
    }

    .group-info {
      position: relative;
      width: 702px;
      height: 200px;
      margin-top: 44px;

      .info-wrap {
        position: absolute;
        left: 16px;
        top: 0;
        z-index: 2;
        width: 670px;
        height: 186px;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        background: #f7f7f7;

        > p {
          @include flex-box(space-between, flex-end);
          @include border-box(0 30px 0 44px);
          margin: 20px 0 42px;

          > span:first-child {
            line-height: 34px;
            font-size: 24px;
            font-weight: 600;
            color: $secondFontColor;

            > a {
              font-size: 50px;
              font-weight: bold;
            }
          }

          > span:last-child {
            line-height: 34px;
            font-size: 24px;
            font-weight: 500;
            color: #cccccc;
          }
        }

        > .enter-links {
          @include flex-box(space-between, center);

          > a {
            @include flex-box(center, center);
            flex: 1;
            text-align: center;
            font-size: 32px;
            font-weight: 600;
            color: rgba(102, 102, 102, 1);
            background: linear-gradient(
              270deg,
              rgba(251, 202, 57, 1) 0%,
              rgba(250, 155, 0, 1) 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

            &:first-child {
              position: relative;

              &::after {
                position: absolute;
                right: 0;
                top: 8px;
                z-index: 1;
                width: 1px;
                height: 28px;
                content: "";
                background: linear-gradient(
                  270deg,
                  rgba(251, 202, 57, 1) 0%,
                  rgba(250, 155, 0, 1) 100%
                );
              }
            }
          }
        }
      }

      .border-bottom {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 1;
        width: 100%;
        height: 26px;
        border-radius: 13px;
        background: #d7d8d9;
      }
    }
  }

  .service-tel {
    @include flex-box(space-between, center);
    @include border-box(40px);
    width: 100%;
    height: 100px;
    background: $blockBgColor;
    margin-bottom: 22px;

    > span:first-child {
      line-height: 40px;
      font-size: 28px;
      color: $baseFontColor;
    }

    > span:last-child {
      line-height: 42px;
      font-size: 30px;
      font-weight: 500;
      color: $secondFontColor;

      > a {
        color: $secondFontColor;
      }
    }
  }

  .logout-btn {
    @include flex-box(center);
    margin-top: 10px;
    height: 104px;
    background: #fff;

    > span {
      line-height: 44px;
      font-size: 32px;
      font-weight: 500;
      color: $secondFontColor;
    }
  }
}
</style>
